import React, { useEffect } from "react";
import { LoginContextData } from "../Declarations";
import { useQuery } from "@tanstack/react-query";
import { createAxiosClient } from "@ntg/component-library/utilities";

interface IEvaluate2FARequirementProps {
    data: LoginContextData;
    onDecision: (shouldConfigure2FA: boolean) => void;
}

export const Evaluate2FARequirement = ({ data, onDecision }: IEvaluate2FARequirementProps) => {
    const axiosAuth = createAxiosClient("Auth");

    const query = useQuery({
        enabled:
            data.UserName !== undefined &&
            data.Password !== undefined &&
            data.UserID !== undefined &&
            data.BrowserFingerprint !== undefined,
        queryFn: async (): Promise<boolean> => {
            const res = await axiosAuth.post<boolean>(
                "/UILogin/Requires2FASetup",
                {
                    BrowserFingerPrint: data.BrowserFingerprint,
                    Password: data.Password,
                    UserAgent: navigator.userAgent,
                    UserID: data.UserID,
                    UserName: data.UserName,
                },
                {
                    headers: {
                        "Content-Type": "application/json",
                    },
                }
            );

            return res.data; // false = needs setup, true = already configured
        },
        queryKey: [
            "check2fa",
            data.UserName,
            data.Password,
            data.UserID,
            data.BrowserFingerprint,
        ],
    });

    useEffect(() => {
        if (query.isSuccess) {
            onDecision(query.data);
        }
    }, [query.isSuccess, query.data, onDecision]);

    if (query.isLoading) {
        return <p>Checking 2FA status...</p>;
    }

    if (query.isError) {
        return <p className="error">Failed to check 2FA status.</p>;
    }

    return null;
};
